import React from 'react';
import fireTv from '../img/firetv.png';
import IconBadge from './IconBadge';

const Badge: React.FC<React.PropsWithChildren<unknown>> = props => (
  <IconBadge url={fireTv.src} {...props} />
);

export default Badge;
